import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_TERMED_TITLE,
	ONBOARDING_ERROR_TERMED_DESCRIPTION,
	ONBOARDING_ERROR_TERMED_DESCRIPTION_NPL,
	ONBOARDING_ERROR_TERMED_CTA,
} from '../../../../constants/Copy';
import { ROUTE_HOME } from '../../../../constants/Routes';

const DefaultTermedError = ({ history, isNPL }) => (
	<FullPageMessage
		button={{
			onClick: () => history.push(ROUTE_HOME),
			testValue: ROUTE_HOME,
			text: ONBOARDING_ERROR_TERMED_CTA,
		}}
		title={ONBOARDING_ERROR_TERMED_TITLE}
		description={
			<span
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: isNPL
						? ONBOARDING_ERROR_TERMED_DESCRIPTION_NPL
						: ONBOARDING_ERROR_TERMED_DESCRIPTION,
				}}
			></span>
		}
	/>
);

DefaultTermedError.propTypes = {
	history: PropTypes.object.isRequired,
	isNPL: PropTypes.bool,
};

export default DefaultTermedError;
